export default __webpack_public_path__ + "assets/c2f42b2351a3cabae1bfa06d34f7f5a5.jpg";